import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["days", "hours", "minutes", "seconds"]
    static values  = { endDate: String }

    connect() {
        this.tick()
        this.intervalId = setInterval(() => this.tick(), 1000)
    }

    disconnect() {
        clearInterval(this.intervalId)
    }

    tick() {
        const diff = Math.max(0, new Date(this.endDateValue).getTime() - Date.now())

        if (diff === 0) {
            clearInterval(this.intervalId)
        }

        const days    = Math.floor(diff / 86_400_000)
        const hours   = Math.floor((diff % 86_400_000) / 3_600_000)
        const minutes = Math.floor((diff % 3_600_000)  / 60_000)
        const seconds = Math.floor((diff % 60_000)     / 1_000)

        this.daysTarget.textContent    = String(days).padStart(2, "0")
        this.hoursTarget.textContent   = String(hours).padStart(2, "0")
        this.minutesTarget.textContent = String(minutes).padStart(2, "0")
        this.secondsTarget.textContent = String(seconds).padStart(2, "0")
    }
}
